module.exports = __webpack_public_path__ + "img/box-arrow-in-up.0a11e27c.svg";